import Registration from './Registration'
import { connect } from 'react-redux';
import * as actions from '../../Actions'

const mapStateToProps = (state) => {
  const { quote } = state.commercialQuote;
  return {
    error: state.user.registrationError,
    email: state.user.email,
    user: state.user.user,
    pricingCalc: state.pricingCalc.data,
    orderSubmit: state.orderSubmit.data,
    quote,
    ResRegister: state.ResRegister,
    Login: state.Login
  }
}

const mapDispatchToProps = {
  registerUser: actions.registerUser,
  ResidentialRegister: actions.residentialRegister,
  loginUser: actions.loginUser,
  cleanResLeadResponse: actions.cleanResLeadResponse,
  updateCustomerLastCompletedStep: actions.updateCustomerLastCompletedStep,
}

export default (connect(mapStateToProps, mapDispatchToProps)(Registration));